import { apiClient } from "./client";
import { repairAndParseJSON } from "../utils/jsonRepair";
import { mapProduct } from "../utils/productMapper";

export const getProducts = async (params = {}) => {
    const { 
        catgId = "", 
        subCatgId = "", 
        sortBy = "", 
        pageNumber = 1, 
        rows = 10, 
        priceLow = 0, 
        priceHigh = 0,
        material = "",
        transparency = ""
    } = params || {};
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get("/PRODUCTS", {
            params: {
                CATGID: catgId,
                subcatgid: subCatgId,
                sortby: sortBy,
                pagenumber: pageNumber,
                rows: rows,
                PRICELOW: priceLow < 1 ? 0 : priceLow,
                PRICEhigh: priceHigh,
                MOBNO: mobno,
                material: material ?? "",
                transparency: transparency ?? ""
            },
            headers: {
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            const data = repairAndParseJSON(response.data);
            if (!data) return { products: [], totalCount: 0 };
            
            const rawItems = data.Data || data.data || (Array.isArray(data) ? data : []);
            const items = rawItems.map((item, index) => mapProduct(item, index));

            let totalCount = data.TotalCount || data.totalCount;
            if (!totalCount && rawItems.length > 0) {
                const firstItem = rawItems[0];
                const totprds = firstItem.totprds || firstItem.TOTPRDS;
                if (totprds) {
                    totalCount = parseInt(totprds, 10);
                }
            }
            if (isNaN(totalCount) || !totalCount) {
                totalCount = items.length;
            }

            return {
                products: items,
                totalCount: totalCount
            };
        }
        return { products: [], totalCount: 0 };
    } catch (error) {
        console.error("PRODUCTS API failed", error);
        throw error;
    }
};

export const getBestSellers = async (params = {}) => {
    const {
        sortBy = "a.prd_code",
        pageNumber = 1,
        rows = 10,
        priceLow = 0,
        priceHigh = 0,
        cnd = ""
    } = params || {};
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get("bestseller", {
            params: {
                sortby: sortBy,
                pagenumber: pageNumber,
                rows: rows,
                pricelow: priceLow,
                pricehigh: priceHigh,
                mobno: mobno,
                cnd: cnd
            },
            headers: {
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            return repairAndParseJSON(response.data);
        }
        return [];
    } catch (error) {
        console.error("bestseller API failed", error);
        throw error;
    }
};
export const getProductDetails = async (params = {}) => {
    const {
        catgId = "",
        subCatgId = "",
        sortBy = "",
        pageNumber = 1,
        rows = 10,
        priceLow = 0,
        priceHigh = 0,
        prd_code = ""
    } = params || {};
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get("/PRDDETAIL", {
            params: {
                CATGID: catgId,
                subcatgid: subCatgId,
                sortby: sortBy,
                pagenumber: pageNumber,
                rows: rows,
                PRICELOW: priceLow < 1 ? 1 : priceLow,
                PRICEhigh: priceHigh,
                MOBNO: mobno,
                prd_code: prd_code
            },
            headers: {
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            const data = repairAndParseJSON(response.data);
            if (!data) return [];
            return data.Data || data.data || (Array.isArray(data) ? data : []);
        }
        return [];
    } catch (error) {
        console.error("PRDDETAIL API failed", error);
        throw error;
    }
};

export const updateWishlist = async (params = {}) => {
    const { prd_code, fav } = params;
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get("FAVPRDUPD", {
            params: {
                mobno: mobno,
                prd_code: prd_code,
                fav: fav
            },
            headers: {
                token: token,
                loginname: loginname
            }
        });
        return repairAndParseJSON(response.data);
    } catch (error) {
        console.error("FAVPRDUPD API failed", error);
        throw error;
    }
};

export const getWishlist = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get("favprd", {
            params: {
                mobno: mobno
            },
            headers: {
                token: token,
                loginname: loginname
            }
        });
        
        if (response.data) {
            const data = repairAndParseJSON(response.data);
            if (!data) return [];
            
            const rawItems = data.Data || data.data || (Array.isArray(data) ? data : []);
            return rawItems.map((item, index) => mapProduct(item, index));
        }
        return [];
    } catch (error) {
        console.error("favprd API failed", error);
        throw error;
    }
};

export const searchProducts = async (searchText) => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";
    const mobno = localStorage.getItem("mobno") || loginname;

    try {
        const response = await apiClient.get("SEARCH", {
            params: {
                searchtext: searchText,
                mobno: mobno
            },
            headers: {
                token: token,
                loginname: loginname
            }
        });
        
        if (response.data) {
            return repairAndParseJSON(response.data);
        }
        return { Status: 0, Data: [] };
    } catch (error) {
        console.error("SEARCH API failed", error);
        throw error;
    }
};

export const getBrands = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";

    try {
        const response = await apiClient.get("BRAND", {
            headers: {
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            const data = repairAndParseJSON(response.data);
            if (!data) return [];
            return data.Data || data.data || (Array.isArray(data) ? data : []);
        }
        return [];
    } catch (error) {
        console.error("BRAND API failed", error);
        throw error;
    }
};

export const getTransparencies = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";

    try {
        const response = await apiClient.get("TRANSPARENCY", {
            headers: {
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            const data = repairAndParseJSON(response.data);
            if (!data) return [];
            return data.Data || data.data || (Array.isArray(data) ? data : []);
        }
        return [];
    } catch (error) {
        console.error("TRANSPARENCY API failed", error);
        throw error;
    }
};

export const getMaterials = async () => {
    const token = localStorage.getItem("token") || "";
    const loginname = localStorage.getItem("loginname") || "";

    try {
        const response = await apiClient.get("MATERIAL", {
            headers: {
                token: token,
                loginname: loginname
            }
        });

        if (response.data) {
            const data = repairAndParseJSON(response.data);
            if (!data) return [];
            return data.Data || data.data || (Array.isArray(data) ? data : []);
        }
        return [];
    } catch (error) {
        console.error("MATERIAL API failed", error);
        throw error;
    }
};

